export const lafiaUser_profile_img_path = (state) => {
  return state.lafia_user.profile_image.includes("/") ? state.lafia_user.profile_image : "/upload/user/profile_image/" + state.lafia_user.profile_image
}

export const isKRW = (state) => state.lang === "ko"
